export enum RequestMethods {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

export enum AppRoutes {
  HOME = "/",
  ACCOUNTS = "/accounts",
  ACCOUNT = "/account",
  ACCOUNTS_LIST = "/accounts/list",
  CAMPAIGNS = "/campaigns",
  CAMPAIGNS_REQUIREMENTS = "/campaigns/requirements",
  LOGIN = "/login",
  REGISTRATION = "/sign-up",
  FORGOT_PASSWORD = "/forgot-password",
  PROFILE = "/profile",
  CREATE_CAMPAIGN = "/create-campaign",
  REVIEWS = "/reviews",
  AUTH = "/oauth/callback",
  ACCOUNT_PLAN = "/account-plan",
  PLAYBOOK = "/playbook",
  Welcome = "/welcome",
  CLIENTS = "/clients",
  PERMISSIONS = "/permissions",
  CRM = "/crm",
  CRM_OAUTH = "/crm/oauth",
  MARKETO_GUIDE = "/marketo-guide",
}

export enum KeyRoles {
  final_decision_maker = "final_decision_maker",
  budget_owner = "budget_owner",
  technical_evaluator = "technical_evaluator",
  security_compliance = "security_compliance",
  procurement_legal = "procurement_legal",
  subject_matter_expert = "subject_matter_expert",
  other_stakeholder = "other_stakeholder",

  // initiator = "initiator",
  // influencer = "influencer",
  // champion = "champion",
  // blocker = "blocker",
}

export enum RateIndicator {
  up = "up",
  down = "down",
}

export enum Groups {
  cluster = "cluster",
  committee = "committee",
}

export enum RoleStatus {
  active = "active",
  disabled = "disabled",
  excluded = "excluded_for_size",
}

export enum JobTitlesType {
  ignored = "ignored",
  approved = "approved",
  suggested = "suggested",
}

export enum AccountPlanStatus {
  ready = "ready",
  in_progress = "in_progress",
  completed = "completed",
  failed = "failed",
  updating = "updating",
  needs_update = "needs_update",
  account_plan_generating = "account_plan_generating",
}

export enum NotificationTypes {
  scraping = "scraping",
  analysis = "analysis",
  account_plan_generation = "account_plan_generation",
  sdr_playbook_generation = "sdr_playbook_generation",
}

export enum ActivitiesStatus {
  in_progress = "in_progress",
  completed = "completed",
  failed = "failed",
  queued = "queued",
  updating = "updating",
}

export enum ShareCampaignRoles {
  editor = "editor",
  owner = "owner",
  admin = "admin",
}

export enum Integration {
  hubspot = "hubspot",
  salesforce = "salesforce",
  lead_tools = "lead_tools",
  marketo = "marketo",
}

export const IntegrationDisplayName: Record<Integration, string> = {
  [Integration.hubspot]: "HubSpot",
  [Integration.salesforce]: "Salesforce",
  [Integration.lead_tools]: "LeadTools",
  [Integration.marketo]: "Marketo",
};

export enum PlaybookPlanNames {
  account_plan = "Account Intelligence Plan",
  account_plans = "Account Intelligence Plans",
  playbook = "Buyer Intelligence Card",
  playbooks = "Buyer Intelligence Cards",
}

export enum ManageSectionsModals {
  account_plan = "Account Intelligence Plan",
  playbook = "Buyer Intelligence Card",
  none = "",
}

export enum ExportAccountsOptions {
  all = "All Accounts",
  selected = "Selected Accounts",
  source = "Data Source",
}

export enum ExportDataModals {
  account_plan = "Account Intelligence Plans (PDF)",
  account_plan_links = "Account Intelligence Plan Links (CSV)",
  csv = "Analysis Report (CSV)",
  playbook = "Buyer Intelligence Card Links (CSV)",
  none = "",
}

export enum ManageFields {
  sdr_playbook_fields = "sdr_playbook_fields",
  account_plan_fields = "account_plan_fields",
}

export enum GenerateReportsModals {
  account_plan = "Account Intelligence Plans",
  playbook = "Buyer Intelligence Cards",
  none = "",
}

export enum PlaybookFilter {
  all = "all",
  without_playbooks = "without_playbooks",
  with_playbooks = "with_playbooks",
}

export enum ColumnType {
  grid = "grid",
  row = "row",
}

export enum BuyerJourneyOption {
  target = "Target",
  awareness = "Awareness",
  consideration = "Consideration",
  decision = "Decision",
  purchase = "Purchase",
}

export enum ButtonsColorType {
  blue = "blue",
  blue_white = "blue_white",
  gradient = "gradient",
  dark_orange = "dark_orange",
  grey = "grey",
  red_white = "red_white",
  red = "red",
}

export enum ButtonsType {
  contained = "contained",
  outlined = "outlined",
  text = "text",
}

export enum UploadMethodsOption {
  crm = "Connect Data",
  desktop = "Upload File",
  manually = "Manually",
  cid = "Sync by CID",
}

export enum topicTitlesMapper {
  read_first = "Understanding the Prospect Type",
  do_dont = "Do’s and Don'ts for Engaging Intent-Based Prospects",
  lead_details = "Prospect Details",
  outreach_research = "Part 1: Immediate Prep + Fast Track Outreach (Day 0-3)",
  outbound_sequence = "Part 2: 7-Day Outbound Sequence (Day 3–10)",
  first_call = "SDR First Call Script",
  amnesia_best_practices = "Prospect Amnesia Best Practices",
  crm_notes = "CRM Notes to Capture",
}

export enum ClientTags {
  clients = "clients",
}

export enum CampaignPurpose {
  sales = "sales",
  demo = "demo",
  base = "base",
}

export enum DataSources {
  crm_data = "CRM",
  infuse_data = "INFUSE",
  infuse_extended = "INFUSE Extended",
}

export enum AccountsFilters {
  sizes = "Sizes",
  regions = "Regions",
  industries = "Industries",
  buyer_journey = "Buyer's Journey",
  data_source = "Data Source",
}

export enum PermissionRoles {
  client = "client",
  sales = "sales",
  agency_team = "agency_team",
  cs = "cs",
  cm = "cm",
  gtm = "gtm",
  deal_desk = "deal_desk",
  list_gen = "list_gen",
  admin = "admin",
}

export enum TierType {
  high = "tier_1",
  medium = "tier_2",
  low = "tier_3",
}

export enum RolesTierType {
  authority = "Authority Tier",
  evaluation = "Evaluation Tier",
  commercial = "Commercial Tier",
  adoption = "Adoption Tier",
}

export enum RolesPriorityTag {
  early = "early",
  mid = "mid",
  late = "late",
  all = "all",
}

export enum RolesActionTag {
  first = "first",
  second = "second",
  complete = "complete",
}

export enum ModalSize {
  small = "540px",
  small_mid = "600px",
  mid = "640px",
  big = "660px",
}
